export default {
	loginExpired: '登录已失效，请重新登录',
	login: '登录',
	loginAccount: '登录账号',
	logout: '退出登录',
	personalInfo: '个人信息',
	purchasingPlatformAccount: '代购平台账号',
	purchasingWarning: '温馨提示：新增代购平台后，可解锁批量加入三方购物车的功能，如您变更了代购平台的密码，请您同步更新，以免影响您的使用',
	add: '新增',
	batchDelete: '批量删除',
	default: '默认',
	account: '账号',
	moveUp: '↑上移',
	moveDown: '↓下移',
	setAsDefault: '设为默认',
	edit: '编辑',
	delete: '删除',
	register: '注册',
	emailPlaceholder: '请输入电子邮箱',
	passwordPlaceholder: '请输入密码',
	forgotPassword: '忘记密码',
	loginSuccess: '登录成功',
	inputError: '输入有误，请检查',
	loginToViewCart: '登录可查看您的购物车信息',
	loginToViewProfile: '登录可查看个人信息',
	home: '首页',
	productFavorites: '商品收藏',
	followedMerchants: '关注商家',
	browsingHistory: '浏览记录',
	complaintsFeedback: '投诉与反馈',
	inquiryRecords: '询价记录',
	welcome: '欢迎访问我们的网站！',
	welcomeToSourcefind: '欢迎来到Sourcefind',
	loginSlogan: '让所有海外用户直接访问中国一手货源',
	username: '用户名',
	password: '密码',
	confirmPassword: '确认密码',
	email: '邮箱',
	email2: '电子邮箱',
	submit: '提交',
	confirm: '确认',
	cancel: '取消',
	language: '语言',
	search: '搜索',
	searchPlaceholder: '请输入商品关键词',
	searchStorePlaceholder: '请输入商家关键词',
	storeSearchPlaceholder: '店内搜索',
	storeSearchButton: '店内搜索',
	searchByImage: '按图片搜索',
	selectPlatforms: '根据采购平台选择商品',
	bestSellers: '畅销商品',
	merchants: '商家',
	join: '加入我们',
	feeSchedule: '入驻费用一览表',
	memberLevel: '会员等级',
	annualFee: '入驻费用(元/年)',
	dailySearchUpload: '搜图上新商品(件/日)',
	windowItems: '橱窗上新商品数(件)',
	dailyWindowRefresh: '橱窗刷新商品(件/日)',
	customerServiceHours: '专属客服支持(小时)',
	contactServiceNow: '联系客服立即入驻',
	cart: '购物车',
	cartEmpty: '您的购物车是空的',
	delete: '删除',
	totalSKU: '共有SKU',
	unit: '个',
	unitPiece: '件',
	items: '商品',
	viewAll: '查看全部',
	viewMoreProducts: '查看更多商品',
	howItWorks: '如何使用',
	companyInfo: '公司信息',
	aboutSourcefind: '关于Sourcefind',
	becomeMerchant: '成为入驻商家',
	feedbackSuggestions: '反馈与建议',
	contactSupport: '联系平台客服',
	legalTerms: '法律条款',
	privacyPolicy: '隐私条款',
	termsOfService: '服务条款',
	cookieStatement: 'Cookie声明',
	scanToDownload: '扫码下载',
	downloadAppleStore: '下载App Store',
	downloadGooglePlay: '下载Google Play',
	copyright: 'Sourcefind. 版权所有。',
	app: 'APP',
	discord: 'Discord',
	relay: '转发',
	enquiry: '询价',
	complaint: '投诉',
	top: 'TOP',
	discordMeetFriends: '结识同样喜欢中国商品的朋友',
	discordScanToFollow: '扫码关注',
	discordJoinPlatform: '加入Discord平台',
	newlyAdded: '最新加入',
	enquiryTitle: '提交询价',
	enquiryTipTitle: '温馨提示：',
	// Product filter translations
	defaultSort: '默认排序',
	salesSort: '销量排序',
	newestSort: '最新排序',
	allPlatforms: '全部代购平台',
	cnFans: 'CNFans',
	oopbuy: 'Oopbuy',
	mulebuy: 'Mulebuy',
	allChinaBuy: 'AllChinabuy',
	allPrices: '全部价格',
	allBrands: '全部品牌',
	shippingOption: '含/不含邮费',
	withShipping: '含邮费',
	withoutShipping: '不含邮费',
	enquiryTipContent: '您发布求购询价后，我们会根据您所需的商品类型将对应信息推送给平台所有商家，手中有对应商品的商家会在第一时间联系您，请您留意商家聊天的信息。',
	enquiryTipAlert: '如数量及价格区间未填写时，则默认无上限！',
	purchaseType: '求购类型',
	selectPlaceholder: '请选择',
	clothing: '服装',
	bags: '包包',
	shoes: '鞋子',
	contactEmail: '联系电子邮箱',
	emailPlaceholder: '请输入您的邮箱',
	urgencyLevel: '紧急程度',
	veryUrgent: '非常紧急（1天）',
	urgent: '紧急（3天）',
	normal: '一般（7天）',
	purchaseQuantity: '购买数量',
	quantityPlaceholder: '请输入数量',
	priceRange: '价格区间',
	priceRangePlaceholder: '请输入价格',
	productDescription: '商品描述',
	descriptionPlaceholder: '请描述商品需求',
	referenceImages: '参考图片',
	uploadSubmitted: '图片上传成功',
	purchaseTypeRequired: '请选择求购类型',
	emailRequired: '请输入电子邮箱',
	emailInvalid: '请输入有效的电子邮箱',
	urgencyLevelRequired: '请选择紧急程度',
	descriptionRequired: '请输入商品描述',
	imagesRequired: '请上传参考图片',
	enquirySubmitted: '询价提交成功！',
	enquiryFailed: '询价提交失败！',
	formValidationFailed: '请填写所有必填项',
	imageTypeError: '仅支持图片格式',
	imageSizeError: '图片大小不能超过2MB',
	complaintTitle: '提交投诉',
	complaintType: '投诉类型',
	productRelated: '商品相关',
	merchantRelated: '商家相关',
	serviceRelated: '服务相关',
	otherIssues: '其他问题',
	complaintTypeRequired: '请选择投诉类型',
	complaintContent: '投诉内容',
	complaintContentPlaceholder: '请描述投诉内容',
	complaintContentRequired: '请输入投诉内容',
	attachment: '上传附件',
	attachmentRequired: '请上传附件',
	complaintSubmitted: '投诉提交成功！',
	complaintFailed: '投诉提交失败！',
	linkCopied: '链接已复制到剪贴板！',
	complaintTipContent: '给您带来不好的体验，非常抱歉！我们将在24小时内处理您的投诉，请您不要进行恶意投诉否则您将被系统识别并警告，同时建议您先与商家沟通解决您的问题。',
	complaintTipAlert: '如您要投诉商家或商品对应的商家，请在商品页或商家页面进行投诉！',
	relateProduct: '相关商品',
	productIntroduction: '商品描述',
	sales: '销量',
	goToBuy: '立即购买',
	customerService: '客服',
	addToCart: '加入购物车',
	saveItem: '收藏',
	saveItemSuccess: '收藏成功',
	saveItemFail: '收藏失败',
	saveItemCancel: '收藏取消',
	fans: '粉丝',
	sold: '已售',
	follow: '关注',
	unfollow: '取消关注',
	followSuccess: '关注成功',
	followFail: '关注失败',
	followCancel: '关注取消',
	enter: '进入',
	// Complaint List translations
	pendingReview: '待审核',
	complaintNumber: '投诉单号',
	applicationTime: '申请时间',
	complaintMerchant: '投诉商家',
	complaintDescription: '投诉描述',
	viewApprovalRecords: '查看审批记录',
	cancelComplaint: '撤销投诉',
	// Enquiry List translations
	enquiryNumber: '求购编号',
	urgencyLevel: '紧急程度',
	remainingTime: '剩余时间',
	purchaseType: '求购类型',
	priceRange: '价格范围',
	purchaseQuantity: '购买数量',
	viewQuotes: '查看报价',
	revoke: '取消询价',
	recommendSize: '尺码。',
	inventory: '库存',
	selected: '已选',
	total: '共计',
	searchImageTitle: '上传图片搜索',
	uploadImage: '上传图片',
	againUploadImage: '再次上传图片',
	searchImageTip: '如果您有超过6张识图的需求请您使用',
	searchImageTip2: '大批量识图搜索',
	searchImageTip3: '来进行检索商品',
	// Product search by more image
	serialNumber: '序号',
	productImage: '商品图片',
	matchedProducts: '为您匹配的商品',
	foundSimilarSource: '已为您找到相似货源',
	selectAll: '全选',
	selectedItems: '已选择',
	products: '个商品',
	canUploadImages: '可上传图片',
	allSourceGoods: '全部货源',
	currentSelection: '当前选择',
	selectThisSource: '选择这个货源',
	buyChineseProductsEasy: '购买中国商品很简单',
	buyChineseProductsDesc: '无论线上还是线下，购买中国商品都无比轻松。我们提供了按图片搜索、文字搜索等方式找到对应的商品，就能一键下单。体验我们优质的服务，让您从浏览、购买，全程毫无阻碍，尽享便捷。',
	selectFavoritePlatform: '选择你喜欢的代购平台',
	platformListDesc: '提供了市面上常见的代购平台。无论是CNfans、oopbuy、Mulebuy还是AllChinaBuy一键触达，即可购买',
	goodsDelivered: '心仪的商品送到你的手中',
	afterPurchaseDesc: '当您完成购买后，就可以等待商品送到您的手中了。',
	productInfo: '商品信息',
	productQuantity: '商品数量',
	unitPrice: '单价',
	totalPrice: '总价',
	merchantCustomerService: '商家客服',
	addSKU: '添加SKU',
	lookForSimilar: '查找相似',
	deleteSPU: '删除SPU',
	unavailableProducts: '无法购买的商品',
	purchasingPlatform: '代购平台',
	sellerCount: '卖家数量',
	expandall: '展开全部',
	// 注册页面翻译
	emailVerification: '邮箱验证',
	setPassword: '设置密码',
	verificationCode: '校验码',
	enterVerificationCode: '请输入校验码',
	verificationCodeNote: '输入校验码后将发送邮箱验证码到您的邮箱，请您注意查收',
	emailCode: '邮箱验证码',
	enterEmailCode: '请输入邮箱验证码',
	emailCodeErr: '邮箱验证码错误',
	seconds: '秒',
	sendVerificationCode: '发送验证码',
	country: '国家',
	selectCountry: '请选择您所属的国家',
	enterPassword: '请输入密码',
	nextStep: '下一步',
	complete: '完成',
	cancelRegistration: '如果您现在取消注册，那信息将不会被保存，请问您仍要取消吗?',
	cancelUpdatePassword: '如果您现在取消修改密码，那信息将不会被保存，请问您仍要取消吗?',
	tip: '提示',
	verificationCodeSent: '验证码已发送到您的邮箱，请查收',
	// 注册表单验证消息
	enterEmail: '请输入电子邮箱',
	validEmail: '请输入有效的电子邮箱',
	enterVerificationCode: '请输入校验码',
	selectCountry: '请选择您所属的国家',
	enterPassword: '请输入密码',
	passwordMin: '密码不少于6位',
	passwordMax: '密码不能超过18位',
	passwordStrength: '密码需由大写字母、小写字母、阿拉伯数字、特殊符号，起码两种组合',
	enterConfirmPassword: '请输入确认密码',
	passwordMismatch: '密码不一致',
	verificationCodeError: '校验码输入错误',
	registerSuccess: '注册成功',
	updatePwdSuccess: '密码修改成功',
	changePassword: '修改密码',
	emailExist: '该邮箱已有账号，请您直接登录，如忘记密码，请您在登录页面点击忘记密码找回密码',
	emailNotExist: '邮箱不存在',
	agree: '同意',
	and: '和',
	userAgreement: '用户协议',
	agreeToTermsRequired: '请同意用户协议和隐私政策',
	passwordErr: '密码不正确',
	confirmLogout: '你确定要退出吗?',
	noData: '暂无数据',
	noProduct: '暂无商品',
	dataLoading: '数据加载中...',
	loadingFinish: '已加载全部数据',
	zhSerch: '使用中文进行搜索',
	zhSerchTip1: '我们会将您的输入翻译成中文，以获得更佳的搜索结果。',
	zhSerchTip2: '取消勾选即可查看当前语言的搜索结果',
	// 图片搜索翻译
	manualSelect: '手动选择',
	waitingRecognition: '等待中...',
	recognizingSearching: '搜索中...',
	uploadImageSearch: '请上传图片进行搜索',
	selectSearchArea: '选择搜索区域',
	cancelSelect: '取消选择',
	confirmSelect: '确认选择',
	maxUpload: '最多上传{max}张图片',
	hasUpload: '已上传{filesToAdd}张图片，最多只能上传{max}张',
	waitingSearchResult: '请等待搜索结果',
	minUpload: '请上传至少6张图片',
	moreImageSearchTip: '支持多格式图片批量上传，单批次最多可处理50张图片，智能提取商品主体并忽略拍摄干扰，同款匹配精准度高。',
	selectSuccess: '选择成功',
	deleteNotData: '请选择要删除的图片',
	confirmDelete: '确定要删除选中的 {size} 张图片吗？',
	deleteSuccess: '删除成功',
	deleteOneIMage: '删除上传数据后，本条数据会在识图列表中删除，是否确认删除?',
	loginMessage: '您的登录状态已失效，是否前往登录?',
	gotoLogin: '去登录',
	closeLogin: '暂不登录',
	descriptionLengthError: '您的描述过于简短，请您重新描述',
	closeEnquire: '如果您现在关闭求购，那信息将不会被保存，请问您仍要关闭吗?',
	quantityRangeError: '仅支持正整数，数值上限9999',
	integerError: '请输入正整数',
	priceRangeError: '仅支持正两位小数，数值上限99999.99',
	priceRangeInputError: '价格区间有误，请重新输入',
	unrestricted: '无限制',
	negotiable: '面议',
	within: '以内',
	rise: '起',
	day: '天',
	hours: '小时',
	revokeEnquiry: '确定要取消询价吗?',
	revokeSuccess: '撤回成功',
	revokeFail: '撤回失败，请稍候再试',
	revokeContidion: '只有待审核和已通过状态的求购才能取消',
	searchKeyword: '请输入关键词',
	contactHim: '联系他',
	all: '全部',
	closeComplaint: '如果您现在关闭投诉，那信息将不会被保存，请问您仍要关闭吗?',
	revokeComplaint: '确定要撤销投诉吗?',
	platformIntervention: '确定要申请平台介入吗?',
	applyPlatformIntervention: '申请平台介入',
	notAllowCancelcomplaint: '当前状态不允许撤销投诉',
	noPermission: '无权操作该投诉',
	applyPlatformInterventionReason: '请填写申请平台介入原因',
	notApplyPlatformIntervention: '当前状态不允许申请平台介入',
	applySuccess: '申请成功！',
	applyFail: '申请失败！',
	waitingPlatformProcess: '等待平台处理',
	userSubmitComplaint: '用户提交投诉',
	storeReply: '商家回复',
	userReply: '用户回复',
	userApplyPlatform: '用户申请平台介入',
	platformProcess: '平台介入处理',
	userCancelComplaint: '用户撤销投诉',
	replyContent: '请输入您的回复内容',
	replySuccess: '回复成功！',
	replyFail: '回复失败！',
	notAllowReply: '当前状态不允许回复',
	notIntro: '暂无商品描述',
	sex: '性别',
	selectSex: '请选择性别',
	nickname: '昵称',
	inputNickName: '请输入昵称',
	changeAvatar: '更改头像',
	uploadAvatar: '上传头像',
	uploading: '上传中...',
	personalDesc: '个人简介',
	inputPersonalDesc: '请输入个人简介',
	male: '男',
	female: '女',
	other: '其他',
	purchasingPlatform: '代购平台',
	selectPurchasingPlatform: '请选择代购平台',
	purchasingPlatformAccount: '代购平台账号',
	inputPurchasingPlatformAccount: '请输入代购平台账号',
	purchasingPlatformPassword: '代购平台密码',
	inputPurchasingPlatformPassword: '请输入代购平台密码',
	setAsDefaultPurchasingPlatform: '设为默认下单平台',
	yes: '是',
	no: '否',
	pleaseSetDefaultPurchasingPlatform: '请设置默认下单平台',
	updatePersonalSuccess: '修改成功',
	updatePersonalFail: '修改失败',
	addPurchasingSuccess: '添加成功',
	addPurchasingFail: '添加失败',
	existPurchasing: '代购平台下已存在账号',
	updatePurchasingSuccess: '修改成功',
	updatePurchasingFail: '修改失败',
	settingSuccess: '设置成功',
	selectDeleteData: '请选择要删除的数据',
	deleteTip: '删除后数据不可恢复，是否确认删除?'
}